import React from "react";
import PropTypes from "prop-types";
// import { map, propertyOf, sortBy } from "lodash";
import LinkEl from 'cape-mixer/lib/Link/Link'
import css from "cape-style";

import { ShowItem, Underline } from "./styles";

// export const linkMap = propertyOf({
//   recL5bU5855qMhQT4: "recy5OLOvJNnpWuAD",
//   reclZwOjZuXJVbRg1: "recPkxpU5hm2lfIWC",
//   recnt8Oz3oN0HBKSH: "recdoBpSFrFhf1WwX"
// });

// export function getShowId({ id, key }) {
//   return key || linkMap(id) || id;
// }

function ShowGroup({
  extraChild,
  name,
  displayName,
  id,
  program,
  reception,
  showDate,
  ...props
}) {
  // const showId = getShowId(props);
  return (
    <ShowItem>
      <LinkEl
        routeId="programsDetail"
        programId={id}
        className="block"
        style={css("textReset")}
        top
      >
        <h1 style={css("m0 mb1")}>
          <Underline>{displayName || name}</Underline>
        </h1>
      </LinkEl>
    </ShowItem>
  );
}

ShowGroup.propTypes = {
  extraChild: PropTypes.shape({
    reception: PropTypes.string
  }),
  program: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  reception: PropTypes.string,
  showDate: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};
ShowGroup.defaultProps = {
  extraChild: null,
  reception: null
};
export default ShowGroup;



// WEBPACK FOOTER //
// ./src/components/Programs/ShowGroup.jsx